import { useState, useEffect } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import { ActionSection, InputGroup, Label, ScrollableContent, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles"

export default function DateModal({
    isOpen,
    onClose,
    onSave,
    initialDate,
}) {

    const [selectedDate, setSelectedDate] = useState(
        initialDate ? new Date(initialDate) : null
    )
    useEffect(() => {
        setSelectedDate(initialDate ? new Date(initialDate) : null)

    }, [initialDate])

    if (!isOpen) return null

    const handleSave = () => {
        if (!selectedDate) {
            alert("Please select an expense date.")
            return
        }
        onSave(
            moment(selectedDate).format("YYYY-MM-DD"),
        )
        onClose()
    }

    return (
        <Overlay>
            <ModalWrapper>
                <Header>
                    <ModalTitle>Select Date & Repetition</ModalTitle>
                    <button onClick={onClose} className="text-white">
                        <MdClose size={24} />
                    </button>
                </Header>
                <div className="custom-scrollbar flex h-full flex-col justify-between px-6">
                    <ScrollableContent className="!max-h-[calc(100vh-140px)]">
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="expenseDate">
                                    Select Expense Date *
                                </Label>

                                <div className="relative w-full">
                                    <DatePicker
                                        selected={selectedDate}
                                        onChange={(date) => setSelectedDate(date)}
                                        inline
                                        dateFormat="yyyy-MM-dd"
                                        required
                                        id="expenseDate"
                                        autoComplete="off"
                                        className="w-full"
                                    />
                                </div>

                            </InputGroup>

                        </Wrapper>
                    </ScrollableContent>
                </div>
                <ActionSection>
                    <SideCancelBtn type="button" onClick={onClose}>
                        Cancel
                    </SideCancelBtn>
                    <SubmitBtn type="button" onClick={handleSave}>
                        OK
                    </SubmitBtn>
                </ActionSection>
            </ModalWrapper>
        </Overlay>
    )
}
// Styled wrappers using tailwind-styled-components
const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative `
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const ModalTitle = tw.h2`text-lg font-medium text-white`

